// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FZHXN","content":"styles_content__3vDyP"};